import React from 'react';

const Hero = () => {
  return (
    <header className="relative py-20 px-6 text-center bg-gradient-to-r from-pink-100 via-purple-100 to-blue-100 overflow-hidden">
      {/* Animated Background Sparkles would go here */}
      <h1 className="text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-600 mb-4">
        Handmade with Love & Sparkles
      </h1>
      <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
        Welcome to Georgia's world of bead animals and friendship bracelets! 
        Every creation helps kids in need.
      </p>
      <div className="flex justify-center gap-4">
        <button className="bg-purple-600 text-white px-8 py-3 rounded-full text-lg font-bold hover:shadow-lg transform hover:-translate-y-1 transition">
          View the Collection
        </button>
      </div>
    </header>
  );
};

export default Hero;
